<template>
    <!-- 998弹框 -->
    <van-popup class="act-six-one-eight-pop-box" position="bottom" :value="showActDayLuckPop" :close-on-click-overlay=false >
        <div class="act-six-one-eight-pop act-six-one-eight-fullpage-pop">
            <!-- 顶部会员特权列表 -->
            <div class="act-six-one-eight-vip-title-bg"><div class="act-six-one-eight-vip-title"></div></div>
            <div class="report-act-popup-close" @click="clickClose"><span class="close"></span></div>
            <div id="ActDayLuckContentBox" class="act-six-one-eight-vip-content-box"><div class="act-six-one-eight-vip-content"></div></div>
            <div id="ActDayLuckBgBox" class="act-six-one-eight-bg"  :style="vipDayLuckType == 1 && vipDayLuckInfo && vipDayLuckInfo.pic ? 'background-image: url('+vipDayLuckInfo.pic+')' : vipDayLuckType == 2 && vipYearUpInfo && vipYearUpInfo.pic ? 'background-image: url('+vipYearUpInfo.pic+')' : ''"></div>
            <div class="act-six-one-eight-content">
                <div class="my-vip-bottom-list list-three">
                    <div class="my-vip-bottom-l-item-box">
                        <div class="my-vip-bottom-l-item" :class="{'selected': selectedIndex == 3}" @click="selectItem(3)">
                            <p class="p1">常规活动价</p>
                            <p class="p2">￥<span class="num">{{vipProductData["pay_40020"] ? vipProductData["pay_40020"].price:''}}</span></p>
                            <div class="item-note" v-if="selectedIndex == 3"></div>
                            <div class="item-select" v-if="selectedIndex == 3"></div>
                        </div>
                    </div>
                    <div class="my-vip-bottom-l-item-box">
                        <div class="my-vip-bottom-l-item" :class="{'selected': selectedIndex == 4}" @click="selectItem(4)">
                            <p class="p1">特惠活动价</p>
                            <p class="p2">￥<span class="num">{{vipDayLuckType == 2 && vipYearUpInfo && vipYearUpInfo.product ? vipYearUpInfo.product.price : vipDayLuckInfo && vipDayLuckInfo.product ? vipDayLuckInfo.product.price : '' }}</span></p>
                            <div class="item-note" v-if="selectedIndex == 4"></div>
                            <div class="item-select" v-if="selectedIndex == 4"></div>
                        </div>
                    </div>
                    <div class="my-vip-bottom-l-item-box">
                        <div class="my-vip-bottom-l-item" :class="{'selected': selectedIndex == 2}" @click="selectItem(2)">
                            <p class="p1">日常价</p>
                            <p class="p2">￥<span class="num">{{vipProductData["pay_40002"] ? vipProductData["pay_40002"].price:''}}</span></p>
                            <p class="p3 p4">任性支持购买</p>
                            <div class="item-note item-note-4" v-if="selectedIndex == 2"></div>
                            <div class="item-select" v-if="selectedIndex == 2"></div>
                        </div>
                    </div>
                </div>
                <div class="act-six-one-eight-button">
                    <!-- 每日抢购 -->
                    <button v-if="vipDayLuckType == 2 && selectedIndex == 4" class="act-button" @click="clickButton">
                        {{ vipYearUpTimeSecond > 0 ? '立即抢购，'+vipYearUpTimeStr+'后结束' : "限时已到，抓住机会的尾巴" }}
                    </button>
                    <!-- 年会员升级 -->
                    <button v-else-if="vipDayLuckType != 2 && selectedIndex == 4" class="act-button" :class="{'act-button-gray': vipDayLuckInfo.num == 0}" @click="clickButton">
                        {{ vipDayLuckInfo.num == 0 ? '今日抢购已售罄 明日0点再来！' : '每日特惠还剩'+vipDayLuckInfo.num+'位 立即抢购' }}
                    </button>
                    <button v-else class="act-button" @click="clickButton">立即购买</button>
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils'
import { CONFIG } from '../../modules/config';
export default {
    name: 'VantActivityDayLuckPop',
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        showActDayLuckPop() {
            return this.$store.state.user.showActDayLuckPop;
        },
        vipDayLuckType() {
            return this.$store.state.user.vipDayLuckType;
        },
        vipDayLuckInfo() {
            return this.$store.state.user.vipDayLuckInfo;
        },
        vipYearUpInfo() {
            return this.$store.state.user.vipYearUpInfo;
        },
        vipYearUpTimeSecond() {
            return this.$store.state.user.vipYearUpTimeSecond;
        },
        vipYearUpTimeStr() {
            return this.$store.state.user.vipYearUpTimeStr;
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            selectedIndex: 4
        }
    },
    methods: {
        clickClose() {
            this.selectedIndex = 4;
            this.$store.state.user.showActDayLuckPop = false;
        },
        selectItem(pIndex) {
            this.selectedIndex = pIndex;
        },
        clickButton() {
            let me = this,
                userVip = this.$store.state.userData.info.vip,
                pData = this.selectedIndex == 3 ? this.vipProductData["pay_40020"] : this.vipProductData["pay_40002"],
                curPath = this.$router.history.current.path,
                detailInfo = this.$store.state.detail.personInfo;
            // 处理商品数据
            if(this.selectedIndex == 4) {
                switch(this.vipDayLuckType) {
                    case 0:
                    case 1:
                        pData = this.vipDayLuckInfo.product;
                        if(this.vipDayLuckInfo.num == 0) {
                            console.log('数量不够');
                            return;
                        }
                        break;
                    case 2:
                        pData = this.vipYearUpInfo.product;
                        break;
                    default:
                        break;
                }
            }
            console.log('clickButton----', this.selectedIndex, userVip, pData.pid);
            // 下单参数
            let params = {
                pid: pData.pid,
                ptype: pData.payType[2],
                discount: CONFIG.vip_discount
            }
            // 每日抢购下单时候添加ext=dayLuck
            params = this.selectedIndex == 4 && this.vipDayLuckType == 1 ? Object.assign({ext: 'dayLuck'}, params): params;
            // 发送下单请求
            this.$store.dispatch('pay/createPayOrder', {
                params: params,
                mixParams: {
                    pid: pData.pid,
                    product_name: pData.title,
                    price: pData.price,
                    from: 'pop_dayluck',
                },
                sucCb: function() {
                    console.log('支付VIP成功');
                    // 更新数据
                    if(detailInfo) {
                        if(curPath.indexOf('report') != -1) {
                            me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                        }else if(curPath.indexOf('nature') != -1) {
                            me.$store.dispatch('report/getAiCharacter', {
                                detailInfo: detailInfo
                            });
                        }
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.user.showActDayLuckPop = false;
                    me.$store.state.user.showVipSucPop = true;
                    me.$set(me.$store.state.userData, 'vip', 30);
                    me.$set(me.$store.state.userData.info, 'vip', 30);
                    me.$store.state.user.curSelectPayType = 30;
                    me.$bus.emit('updateMyVipInfo');
                },
                failCb: function() {
                    console.error('支付失败----')
                    me.$toast('支付失败,请稍后再尝试~')
                }
            });
        }
    }
}
</script>